export const colours = {
  'primary': '#ea5329',
  'orange': '#ea5329',
  'offwhite': '#fdfbf7',
  'lightBlue': '#a1dced',
  'lightOrange': '#f7c1ad',
  'olive': 'rgb(162, 177, 172)',
  'secondary': 'rgb(162, 177, 172)',
  'black': '#272525',
  'white': '#ffffff',
  'lightGrey': '#eee',
  'grey': 'rgba(216, 216, 216)',
}
export const fonts = {
  heading: 'bookmania',
  body: 'brother-1816',
};

export const breakpoints = {
  mobile: "600px",
}

export const headerHeight = '65px';
